import { createSlice } from "@reduxjs/toolkit";
import { Error } from "../../models";

// Define el estado inicial
export const EmptyErrorState: Error = {
    idError: "",
    mensaje: "",
}

export const errorSlice = createSlice({
  name: "error",
  initialState: EmptyErrorState,
  reducers: {
    setError: (state, action) => action.payload, // Define el valor del error
    resetError: () => EmptyErrorState, // Resetea el error a su valor inicial
  },
});

// Exporta las acciones
export const { setError, resetError } = errorSlice.actions;

// Exporta el reducer
export default errorSlice.reducer;